import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import {inject, observer} from "mobx-react";
import modalFactory from "../modalFactory";
import TokenItemDetail from "./TokenItemDetail";
import CopyToClipboardButton from "../../CopyToClipboardButton";

const SelectedOptionsDetails = ({
  selectedOptions = [],
  onItemDelete,
  isOpen,
  hideModal,
  searchSessionStore: { templates } = {},
}) => {
  const INITIAL_RENDER_COUNT = 10;
  const [renderCount, setRenderCount] = useState(0);
  const getQueryIDs = () => selectedOptions.map((si) => si.id).join("\n");
  return (
    <Modal show={isOpen} onHide={hideModal}
      onShow={() => setRenderCount(INITIAL_RENDER_COUNT)}
      onEntered={() => setRenderCount(selectedOptions.length)}
      onExited={() => setRenderCount(0)}>
      <Modal.Header closeButton>
        <Modal.Title>
          <span>{`Search Terms List (${selectedOptions.length})`}</span>
          <CopyToClipboardButton title="Copy query IDs" className="flat-button" getText={getQueryIDs}/>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="er-l-dlg-body" autoFocus={true}>
        {selectedOptions.slice(0, renderCount).map((si, idx) => (
          <div key={si.id}>
            <TokenItemDetail entity={{...si, ...si.entity}} onItemDelete={onItemDelete} templates={templates} />
            <br style={{ clear: "both" }} />
            {idx < selectedOptions.length - 1 ? <hr /> : null}
          </div>
        ))}
      </Modal.Body>
    </Modal>
  )
}

SelectedOptionsDetails.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  onItemDelete: PropTypes.func.isRequired,
  selectedOptions: PropTypes.arrayOf(PropTypes.object)
};

const SelectedOptionsDetailsInjected = inject("searchSessionStore")(observer(SelectedOptionsDetails));

export default SelectedOptionsDetailsInjected;
export const TokenDetailsModalProvider = modalFactory(SelectedOptionsDetailsInjected);
